function SymbolEnum(...values) {
    var result = {};
    values.forEach(v => {
        if (DEBUG && result[v]) {
            throw new Error(`Duplicate enumeration item ${v}`);
        }
        result[v] = v;
    });
    Object.freeze(result);

    if (DEBUG && window.Proxy) {
        return new Proxy(result, {
            get: (target, name) => {
                if (target[name] === undefined) {
                    throw new Error(`Enum has no member ${name}.`);
                }
                return target[name];
            }
        });
    }
    return result;
}

function DBEnum(values) {
    var inverted = {};
    Object.keys(values).forEach(key => {
        if (DEBUG && inverted[values[key]]) {
            throw new Error(`Duplicate enumeration item { ${key}: ${values[key]} }.`);
        }
        inverted[values[key]] = key;
    });

    Object.defineProperty(values, 'nameByValue', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: function (value) {
            for (var i in values) {
                if (values.hasOwnProperty(i) && values[i] === value) {
                    return i;
                }
            }
        }
    });

    Object.defineProperty(values, 'keys', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: Object.keys(values)
    });

    Object.defineProperty(values, 'values', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: Object.keys(values).map(k => values[k])
    });

    Object.freeze(values);

    if (DEBUG && window.Proxy) {
        return new Proxy(values, {
            get: (target, name) => {
                if (target[name] === undefined) {
                    throw new Error(`Enum has no member ${name}.`);
                }
                return target[name];
            }
        });
    }
    return values;
}

export default function (...values) {
    if (values.length === 1 && typeof values[0] === 'object') {
        return DBEnum(values[0]);
    }
    else if (values.length > 0 && values.every(v => typeof v === 'string')) {
        return SymbolEnum(...values);
    }
    else {
        throw new Error('Can not create enum from values:', values);
    }
};